var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Link } from "react-router-dom";
import { Button, Dimmer, Dropdown, Header, Input, Loader, Menu, Message, Pagination, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import * as countries from "../countries.json";
import { downloadBlob } from "../download";
import { getWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
import { dateOnlyFormat, displayLocalTimestamp } from "./AllOrdersPage";
import DateRangePicker from "./DateRangePicker";
var AllUsersPage = /** @class */ (function (_super) {
    __extends(AllUsersPage, _super);
    function AllUsersPage(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Builds the JSON body for the user list / CSV endpoints. Sent as a POST body rather than a query string
         * because authrocketIds can exceed the server's max URL length.
         */
        _this.buildUserFilterBody = function (pageNumber) {
            var filters = _this.state.appliedFilters;
            var body = { pageNumber: pageNumber };
            if (filters.userFilter !== "") {
                body.userFilter = filters.userFilter;
                body.authrocketIds = _this.state.authrocketUserList
                    .filter(function (u) { return u.email.includes(filters.userFilter); })
                    .map(function (u) { return u.id; });
            }
            if (filters.userCategory !== "") {
                body.userCategory = filters.userCategory;
            }
            if (filters.userStatus !== "") {
                body.userStatus = filters.userStatus;
            }
            if (filters.countryCode !== "") {
                body.countryCode = filters.countryCode;
            }
            if (filters.organization !== "") {
                body.organization = filters.organization;
            }
            if (filters.researchGroup !== "") {
                body.researchGroup = filters.researchGroup;
            }
            if (filters.isPirate !== "") {
                body.isPirate = filters.isPirate === "true";
            }
            if (filters.interval !== undefined) {
                body.createdNotBefore = filters.interval.start.toFormat(dateOnlyFormat);
                body.createdNotAfter = filters.interval.end.toFormat(dateOnlyFormat);
            }
            return JSON.stringify(body);
        };
        _this.downloadCsv = function () {
            _this.setState({ downloading: true });
            postJsonWithAuthn('/admin/users/all-users-csv', _this.buildUserFilterBody(_this.state.currentPage - 1))
                .then(function (resp) {
                if (!resp.ok) {
                    throw new Error(resp.status + " " + resp.statusText);
                }
                return resp.blob();
            })
                .then(function (blob) { return downloadBlob('Users Table.csv', blob, 'text/csv'); })
                .catch(function (rej) {
                console.error("Couldn't download users CSV: " + rej);
            })
                .finally(function () { return _this.setState({ downloading: false }); });
        };
        _this.loadCurrentUserPage = function () {
            var body = _this.buildUserFilterBody(_this.state.currentPage - 1);
            _this.setState({ loading: true, authrocketLoading: true }, function () {
                Promise.all([
                    _this.getAuthrocketUsers(),
                    _this.getUserList(body, _this.state.currentPage)
                ])
                    .catch(function (rej) {
                    console.error("Couldn't load users: " + rej);
                });
            });
        };
        _this.getUserList = function (body, currentPage) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, postJsonWithAuthn('/admin/users/all', body)
                        .then(function (resp) {
                        if (resp.status === 200) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (resp) {
                        if (resp === undefined) {
                            _this.setState({
                                loading: false,
                                error: true
                            });
                        }
                        else {
                            _this.setState({
                                loading: false,
                                users: resp.users,
                                error: false,
                                currentPage: currentPage,
                                totalPages: resp.totalPages
                            });
                        }
                    })];
            });
        }); };
        _this.getAuthrocketUsers = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, getWithAuthn("/admin/users/authrocket/all")
                        .then(function (resp) {
                        if (resp.ok) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (resp) {
                        if (resp === undefined) {
                            _this.setState({
                                error: true,
                                authrocketLoading: false
                            });
                        }
                        else {
                            _this.setState({
                                error: false,
                                authrocketUserList: resp,
                                authrocketLoading: false
                            });
                        }
                    })];
            });
        }); };
        _this.setFilter = function (key, value) {
            _this.setState(function (prev) {
                var _a;
                return ({ filters: __assign(__assign({}, prev.filters), (_a = {}, _a[key] = value, _a)) });
            });
        };
        _this.onSearch = function (e) {
            e.preventDefault();
            _this.setState(function (prev) { return ({
                appliedFilters: prev.filters,
                currentPage: 1,
            }); }, _this.loadCurrentUserPage);
        };
        _this.onClear = function () {
            _this.setState({
                filters: EMPTY_FILTERS,
                appliedFilters: EMPTY_FILTERS,
                currentPage: 1,
            }, _this.loadCurrentUserPage);
        };
        _this.onUserSearchChange = function (_, data) {
            return _this.setFilter('userFilter', data.value);
        };
        _this.onOrganizationChange = function (_, data) {
            return _this.setFilter('organization', data.value);
        };
        _this.onResearchGroupChange = function (_, data) {
            return _this.setFilter('researchGroup', data.value);
        };
        _this.onUserCategoryChange = function (_, data) { var _a; return _this.setFilter('userCategory', (_a = data.value) !== null && _a !== void 0 ? _a : ''); };
        _this.onUserStatusChange = function (_, data) { var _a; return _this.setFilter('userStatus', (_a = data.value) !== null && _a !== void 0 ? _a : ''); };
        _this.onIsPirateChange = function (_, data) { var _a; return _this.setFilter('isPirate', (_a = data.value) !== null && _a !== void 0 ? _a : ''); };
        _this.onCountryCodeChange = function (_, data) { var _a; return _this.setFilter('countryCode', (_a = data.value) !== null && _a !== void 0 ? _a : ''); };
        _this.onIntervalChange = function (interval) { return _this.setFilter('interval', interval); };
        _this.onClearInterval = function () { return _this.setFilter('interval', undefined); };
        _this.onPageChange = function (_, data) {
            var body = _this.buildUserFilterBody(data.activePage - 1);
            _this.setState({ loading: true }, function () {
                _this.getUserList(body, data.activePage)
                    .catch(function (rej) {
                    console.error("Couldn't load users: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            downloading: false,
            error: false,
            users: [],
            authrocketUserList: [],
            authrocketLoading: true,
            filters: EMPTY_FILTERS,
            appliedFilters: EMPTY_FILTERS,
            pageNumber: 0,
            totalPages: 1,
            currentPage: 1,
            loadedUserEmail: ''
        };
        return _this;
    }
    AllUsersPage.prototype.render = function () {
        var _this = this;
        var filters = this.state.filters;
        return React.createElement(React.Fragment, null,
            React.createElement("form", { onSubmit: this.onSearch },
                React.createElement(Menu, { stackable: true, style: { flexWrap: 'wrap', rowGap: '0.5em' } },
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { value: filters.userFilter, onChange: this.onUserSearchChange, placeholder: 'Email or Name' })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { value: filters.organization, onChange: this.onOrganizationChange, placeholder: 'Organization' })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Input, { value: filters.researchGroup, onChange: this.onResearchGroupChange, placeholder: 'Research group' })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Dropdown, { placeholder: 'Organization type', selection: true, clearable: true, options: USER_CATEGORY_OPTIONS, value: filters.userCategory, onChange: this.onUserCategoryChange })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Dropdown, { placeholder: 'Legacy status', selection: true, clearable: true, options: USER_STATUS_OPTIONS, value: filters.userStatus, onChange: this.onUserStatusChange })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Dropdown, { placeholder: 'Pirate', selection: true, clearable: true, options: PIRATE_OPTIONS, value: filters.isPirate, onChange: this.onIsPirateChange })),
                    React.createElement(Menu.Item, null,
                        React.createElement(Dropdown, { placeholder: 'Country', selection: true, search: true, clearable: true, options: COUNTRY_OPTIONS, value: filters.countryCode, onChange: this.onCountryCodeChange }))),
                React.createElement(Menu, { stackable: true, style: { flexWrap: 'wrap', rowGap: '0.5em', alignItems: 'center' } },
                    React.createElement(Menu.Item, null,
                        React.createElement("span", { style: { marginRight: '0.5em', fontWeight: 'bold' } }, "Created:"),
                        React.createElement(DateRangePicker, { dayRangeOptions: [30, 90, 365], interval: filters.interval, onIntervalChange: this.onIntervalChange, includePresets: true }),
                        filters.interval !== undefined &&
                            React.createElement(Button, { type: 'button', icon: 'close', title: 'Clear date range', onClick: this.onClearInterval, style: { marginLeft: '0.5em' } })),
                    React.createElement(Menu.Item, { position: 'right', style: { gap: '0.5em' } },
                        React.createElement(Button, { type: 'submit', primary: true, icon: 'search', labelPosition: 'left', content: 'Search', disabled: this.state.loading, style: { margin: 0 } }),
                        React.createElement(Button, { type: 'button', basic: true, icon: 'eraser', labelPosition: 'left', content: 'Clear', onClick: this.onClear, disabled: this.state.loading, style: { margin: 0 } })))),
            React.createElement(Menu, { stackable: true, style: { flexWrap: 'wrap', rowGap: '0.5em' } },
                React.createElement(Menu.Item, null,
                    React.createElement(Pagination, { totalPages: this.state.totalPages, ellipsisItem: null, onPageChange: this.onPageChange, activePage: this.state.currentPage }))),
            React.createElement(Dimmer.Dimmable, { as: 'div', id: "non-header-portion" },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                React.createElement(Header, null,
                    "Users",
                    React.createElement(Button, { label: "Download", icon: 'download', labelPosition: "left", style: { marginLeft: '5px' }, loading: this.state.downloading, disabled: this.state.downloading, onClick: this.downloadCsv })),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Users could not be loaded."),
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Name"),
                            React.createElement(Table.HeaderCell, { title: 'Account Email' }, "Account Email"),
                            React.createElement(Table.HeaderCell, { title: 'Organization' }, "Organization"),
                            React.createElement(Table.HeaderCell, { title: 'Research Group' }, "Research Group"),
                            React.createElement(Table.HeaderCell, { title: 'Shipping address country code' }, "Country"),
                            React.createElement(Table.HeaderCell, null, "Category"),
                            React.createElement(Table.HeaderCell, { title: 'Legacy (v3.0 Access) status' }, "Status"),
                            React.createElement(Table.HeaderCell, { title: 'Account note contains the pirate flag emoji' }, "Pirate"),
                            React.createElement(Table.HeaderCell, null, "Created"))),
                    React.createElement(Table.Body, null, this.state.users.map(function (o, index) {
                        var _a, _b;
                        return React.createElement(Table.Row, { key: index },
                            React.createElement(Table.Cell, null,
                                React.createElement(Link, { to: AppPaths.ADMIN_USER_BASE + "/" + o.id }, o.name)),
                            React.createElement(Table.Cell, null,
                                " ",
                                _this.state.authrocketLoading
                                    ? React.createElement(Loader, { active: true, inline: true, size: 'small' })
                                    : (_b = (_a = _this.state.authrocketUserList
                                        .find(function (a) { return a.id === o.authrocketId.id; })) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : "Unavailable"),
                            React.createElement(Table.Cell, null, o.organization),
                            React.createElement(Table.Cell, null, o.researchGroup),
                            React.createElement(Table.Cell, null, o.countryCode),
                            React.createElement(Table.Cell, null, o.category),
                            React.createElement(Table.Cell, null, o.userStatus === 'LEGACY' ? 'Legacy (v3.0 Access)' : 'Non-Legacy'),
                            React.createElement(Table.Cell, null, o.isPirate ? '🏴‍☠️' : ''),
                            React.createElement(Table.Cell, null, displayLocalTimestamp(o.createdAt)));
                    })))));
    };
    AllUsersPage.prototype.componentDidMount = function () {
        this.loadCurrentUserPage();
    };
    return AllUsersPage;
}(React.PureComponent));
export default AllUsersPage;
var EMPTY_FILTERS = {
    userFilter: '',
    userCategory: '',
    userStatus: '',
    countryCode: '',
    organization: '',
    researchGroup: '',
    isPirate: '',
    interval: undefined
};
var USER_CATEGORY_OPTIONS = [
    { text: "University", value: "UNIVERSITY" },
    { text: "Government Lab", value: "GOVT_LAB" },
    { text: "Nonprofit Research Institute", value: "NONPROFIT_INST" },
    { text: "Research Hospital", value: "RESEARCH_HOSPITAL" },
    { text: "Company", value: "COMPANY" },
];
var USER_STATUS_OPTIONS = [
    { text: "Legacy (v3.0 Access)", value: "LEGACY" },
    { text: "Non-Legacy", value: "NON_LEGACY" },
];
var PIRATE_OPTIONS = [
    { text: "Pirate 🏴‍☠️", value: "true" }
];
var COUNTRY_OPTIONS = countries
    .map(function (c) { return ({ value: c.value, text: c.text }); });
//# sourceMappingURL=AllUsersPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AllUsersPage.js
// module id = 1271
// module chunks = 0